const setUserInformation = (information) => {
  return {
    type: "SET_USER_INFORMATION",
    data: information.data,
    version: information.Version,
    tax: information.tax,
    ADHDActive: information.ADHDActive,
  };
};
const unsetUserInformation = () => {
  return { type: "SET_USER_INFORMATION", data: {TOFM:''} };
};

export { setUserInformation, unsetUserInformation };
